var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "security"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3777 3.44296L7.37552 1.22171C8.40979 0.762036 9.59037 0.762035 10.6246 1.22171L15.6026 3.43415C17.0583 4.08113 18.0139 5.53525 17.9119 7.12498C17.5206 13.2228 15.7773 15.9793 11.0647 19.1773C9.82104 20.0213 8.18048 20.0192 6.93588 19.1766C2.23776 15.996 0.429713 13.2778 0.0700804 7.1036C-0.0219094 5.5243 0.932081 4.08546 2.3777 3.44296ZM12.5645 8.99356C12.8373 8.68183 12.8057 8.20801 12.494 7.93525C12.1822 7.66249 11.7084 7.69408 11.4356 8.0058L8.56574 11.2857C8.47764 11.3864 8.32589 11.3999 8.22142 11.3163L6.4686 9.91403C6.14515 9.65527 5.67319 9.70772 5.41443 10.0312C5.15567 10.3546 5.20811 10.8266 5.53156 11.0853L7.28438 12.4876C8.01567 13.0726 9.07791 12.9782 9.69461 12.2735L12.5645 8.99356Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.03543db2.svg";
export { ForwardRef as ReactComponent };